import '../Button/Button.css';
import './IconOnlyButton.css';

import { forwardRef } from 'react';

import { cn, generateRdsId } from '../../lib/utils';
import { Button, type ButtonProps } from '../Button';

const ICON_ONLY_BUTTON_RDS_ID = generateRdsId('icon-only-button');

interface IconOnlyButtonProps extends ButtonProps {
  'aria-label': string;
}

const IconOnlyButton = forwardRef<HTMLButtonElement, IconOnlyButtonProps>(
  ({ size = 'md', className, ...props }, forwardedRef) => {
    return (
      <Button
        ref={forwardedRef}
        className={cn(ICON_ONLY_BUTTON_RDS_ID, className)}
        size={size}
        data-sds-id="icon-only-button"
        {...props}
      />
    );
  }
);

export { IconOnlyButton, type IconOnlyButtonProps };
